import React from 'react';
import { useTransactionDetail } from './presenter';
import { TransactionDetailView } from './view';
import { Route } from '../../../components/layout/ProtectedLayout';

type Props = {
  id: string;
  navigate: (r: Route) => void;
};

const TransactionViewPage: React.FC<Props> = ({ id, navigate }) => {
  const vm = useTransactionDetail(id);
  return (
    <TransactionDetailView
      data={vm.data}
      loading={vm.loading}
      error={vm.error}
      onBack={() => navigate({ name: 'transactions/index' as any })}
    />
  );
};

export default TransactionViewPage;
